import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CryptoService } from "../../services/crypto.service";

@Component({
  selector: 'setting-card-detail',
  templateUrl: './card-detail.component.html',
  styleUrls: ['./card-detail.component.scss']
})
export class SettingCardDetailComponent implements OnInit {
  cardForm: any = {
    number: '',
    name: '',
    expire_month: '',
    expire_year: ''
  }

  constructor(
      public auth: AuthService,
      private router: Router,
      private crypto: CryptoService
    ) {}

  ngOnInit() {
    if (this.auth.user.card === undefined) {
      this.router.navigate(['/settings/card']);
    } else {
      this.cardForm = Object.assign({}, this.auth.user.card)
      this.cardForm.name = this.crypto.decrypt(this.cardForm.name)
      this.cardForm.expire_month = parseInt(this.crypto.decrypt(this.cardForm.expire_month))
      this.cardForm.expire_year = parseInt(this.crypto.decrypt(this.cardForm.expire_year))
      this.cardForm.number = this.crypto.decrypt(this.cardForm.number)
    }
  }
}
